module.exports = __webpack_public_path__ + "static/media/Gauge Chart.586842f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/Gauge Chart.svg
// module id = 1042
// module chunks = 0